import { NavLink } from "react-router-dom";
import { parentGuides } from "./content";
import usePageMetadata from "./usePageMetadata";

const groups = [
    { title: "By age", links: parentGuides.slice(0, 3) },
    { title: "By skill", links: parentGuides.slice(3, 5) },
    { title: "Features", links: parentGuides.slice(5) },
];

export default function MathGamesHub() {
    usePageMetadata({
        title: "Math Games for Kids",
        description: "Find age-appropriate MathMinds games and parent guides for multiplication, fractions, offline learning, and ad-free math practice.",
    });

    return (
        <div className="mx-auto grid max-w-[1200px] gap-10 px-5 py-12 sm:px-8 lg:grid-cols-[250px_1fr] lg:py-16">
            <aside className="self-start rounded-3xl border border-[#E9E2CD] bg-white p-6 lg:sticky lg:top-24" aria-label="Parent guide navigation">
                <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#C37C00]">For parents</p>
                {groups.map((group) => (
                    <section key={group.title} className="mt-6">
                        <h2 className="font-bold text-[#283C43]">{group.title}</h2>
                        <ul className="mt-2 space-y-2">
                            {group.links.map((link) => (
                                <li key={link.path}>
                                    <NavLink to={link.path} className="text-sm text-[#327560] hover:underline">{link.label}</NavLink>
                                </li>
                            ))}
                        </ul>
                    </section>
                ))}
            </aside>

            <article>
                <p className="font-bold uppercase tracking-[0.18em] text-[#C37C00]">MathMinds parent guides</p>
                <h1 className="mt-3 font-chango text-4xl leading-tight text-[#327560] sm:text-5xl">Math games for kids</h1>
                <p className="mt-6 max-w-3xl text-lg leading-8 text-[#56635E]">
                    Choose games by age, learning skill, or the way your family likes to play. These guides help parents match practice to a child’s current confidence and goals.
                </p>

                <div className="mt-10 grid gap-5 md:grid-cols-2">
                    {parentGuides.map((guide) => (
                        <NavLink key={guide.path} to={guide.path} className="rounded-3xl border border-[#E9E2CD] bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:border-[#86B7A5]">
                            <h2 className="text-xl font-bold text-[#327560]">{guide.label}</h2>
                            <p className="mt-3 leading-7 text-[#56635E]">{guide.description}</p>
                            <span className="mt-5 inline-block font-bold text-[#327560]">Read guide →</span>
                        </NavLink>
                    ))}
                </div>

                <section className="mt-12 rounded-3xl bg-[#DDF5ED] p-8">
                    <h2 className="font-chango text-2xl text-[#327560]">Ready to play?</h2>
                    <p className="mt-3 leading-7 text-[#56635E]">Explore the complete MathMinds game menu and choose a skill to practice.</p>
                    <NavLink to="/games/memory" className="mt-6 inline-block rounded-full bg-[#F9B818] px-6 py-3 font-bold hover:bg-[#FFCA47]">Open the games</NavLink>
                </section>
            </article>
        </div>
    );
}
